// Hàm dịch duy nhất (TECH_BASELINE §8). Khóa phẳng có chấm, tham số {name}.
import vi from './vi.json';

const DICT: Readonly<Record<string, string>> = vi;

export type I18nParams = Readonly<Record<string, string | number>>;

export function hasKey(key: string): boolean {
  return Object.prototype.hasOwnProperty.call(DICT, key);
}

/**
 * Thiếu khóa thì trả lại chính khóa (dễ thấy trên màn, test bắt được). Tham số dạng chuỗi bắt đầu
 * bằng `@` là một khóa i18n lồng (vd `{ site: '@site.lk.wolfValley.name' }`): Truyền Âm lưu khóa,
 * không lưu câu đã dịch.
 */
export function t(key: string, params?: I18nParams): string {
  const s = DICT[key];
  if (s === undefined) return key;
  if (!params) return s;
  return s.replace(/\{(\w+)\}/g, (m, name: string) => {
    const v = params[name];
    if (v === undefined) return m;
    return typeof v === 'string' && v.startsWith('@') ? t(v.slice(1)) : String(v);
  });
}

export function allKeys(): string[] {
  return Object.keys(DICT);
}
